import {PaymentType} from "../../../App";
import {message, Layout, Typography, Descriptions, Form, Input, Button} from "antd";
import WrappedCard from "../../antd/WrappedCard";
import {Copyable} from "../../common/Copyable";
import React, {useState} from "react";
import {usePostCheckoutApi} from "../../../api";
import {useOrderId} from "../../../hooks/UseOrderId";
import {ProviderTypeEnum} from "../../../types/ProviderTypeEnum";

const rules = {
    customerPhone: [
        {required: true, message: "Please input your mobile number."},
        {
            pattern: /^03\d{9}$/,
            message: "Please enter a valid mobile number, it should start with '03' followed by 9 digits."
        }
    ],
    customerName: [
        {required: true, message: "Please input your name."},
        {max: 64, message: "The length of name cannot exceed 64 chars."}
    ]
};

const placeholders = {
    customerPhone: "03123456789",
    customerName: "Your Real Name"
};

function PkPayItIdMode({getCheckoutInfoData}: PaymentType) {
    const orderId = useOrderId();

    const [isSubmitted, setIsSubmitted] = useState(getCheckoutInfoData?.checkoutStatus === "SUBMITTED");

    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const {loading, executePost} = usePostCheckoutApi(orderId);

    const onFormFinish = (values: any) => {
        executePost({
            data: {
                providerType: ProviderTypeEnum.ONE_BILL,
                ...values
            }
        })
            .then(() => {
                setIsSubmitted(true);
            })
            .catch((error) => {
                const errorMsg = error?.response?.data?.title;
                messageApi.error(errorMsg).then();
            });
    };
    return (
        <Layout.Content>
            {contextHolder}

            {/* 客户信息未提交 */}
            {!isSubmitted &&
              <>
                <WrappedCard
                  cardTitle="Please input your payment information"
                  cardProps={{headStyle: {paddingTop: "1em", paddingBottom: "1em"}}}
                >
                  <Form
                    form={form}
                    onFinish={onFormFinish}
                  >
                    <Form.Item
                      label="Mobile Number"
                      name="customerPhone"
                      rules={rules.customerPhone}
                    >
                      <Input placeholder={placeholders.customerPhone}/>
                    </Form.Item>
                    <Form.Item
                      label="Payment Account Holder Name"
                      name="customerName"
                      rules={rules.customerName}
                    >
                      <Input
                        placeholder={placeholders.customerName}
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={loading}
                      >
                          {loading ? "Submitting..." : "Submit"}
                      </Button>
                    </Form.Item>
                  </Form>
                </WrappedCard>
              </>
            }

            {/* 客户信息已提交 */}
            {isSubmitted &&
              <>
                <WrappedCard
                  cardTitle="Information"
                >
                  <Descriptions
                    bordered
                  >
                    <Descriptions.Item
                      label="Amount Payable"
                    >
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.orderAmount}
                      </Typography.Title>
                    </Descriptions.Item>
                    <Descriptions.Item
                      label="PAYIT Number"
                    >
                      <Typography.Title
                        copyable={{icon: <Copyable/>}}
                        level={5}
                        style={{margin: 0}}
                      >
                          {getCheckoutInfoData?.receiverAccount.slice(6)}
                      </Typography.Title>
                    </Descriptions.Item>
                  </Descriptions>
                </WrappedCard>
                <WrappedCard
                  cardTitle="Instruction"
                >
                  <ol>
                    <li>Open your EasyPaisa</li>
                    <li>Select PAYIT invoice and enter your voucher number</li>
                    <li>Verify your bill details and proceed to payment</li>
                  </ol>
                </WrappedCard>
              </>
            }
        </Layout.Content>
    );
}

export default PkPayItIdMode;